export const setLoading = (value)=>{
    return {
        type:"SET_LOADING",
        payload:value
    }
}